module.exports = __webpack_public_path__ + "img/slide7.a772023f.png";